const Genero = [
    {
        name: "TECHNO",
        url: "/genres/melodic-house&techno",
        img: "https://i.imgur.com/d9X259J.gif",
        title: "Melodic House & Techno",
    },
    {
        name: "ELECTRONIC",
        url: "/genres/electronic&downtempo",
        img: "https://i.imgur.com/hRhl8Io.gif",
        title: "Electronic & DownTempo",
    },
    {
        name: "TROPICAL HOUSE",
        url: "/genres/tropical-house",
        img: "https://i.imgur.com/o0Eiksi.gif",
        title: "Tropical House",
    },
    {
        name: "TECH HOUSE",
        url: "/genres/tech-house",
        img: "https://i.imgur.com/cyzPRiY.gif",
        title: "Tech House",
    },
    {
        name: "DEEP TECH",
        url: "/genres/minimal&deep-tech",
        img: "https://i.imgur.com/eJ4qfj6.gif",
        title: "Minimal & Deep Tech",
    },
    {
        name: "DEEP HOUSE",
        url: "/genres/house&deep-house",
        img: "https://i.imgur.com/ETWjzCP.gif",
        title: "House & Deep House",
    }
]

export default Genero;